import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

export type InlineConfirmProps = {
  /** Question shown before the buttons ("Archiver ?"); optional. */
  message?: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  className?: string;
};

/** Second step of a two-step destructive action, shown in place of its button. */
export function InlineConfirm({
  message,
  confirmLabel,
  cancelLabel,
  busy = false,
  onConfirm,
  onCancel,
  className,
}: InlineConfirmProps) {
  return (
    <div
      role="group"
      className={cn(
        'flex flex-wrap items-center gap-2 rounded-xl border border-destructive/30 bg-destructive/10 p-3',
        className
      )}
    >
      {message && <span className="mr-auto text-sm text-foreground">{message}</span>}
      <Button variant="destructive" size="sm" onClick={onConfirm} disabled={busy}>
        {busy && <Spinner size="sm" />}
        {confirmLabel}
      </Button>
      <Button variant="outline" size="sm" onClick={onCancel} disabled={busy}>
        {cancelLabel}
      </Button>
    </div>
  );
}
